
import { defineComponent, PropType, ref } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { Post } from '@/typings';
import * as timeago from 'timeago.js';
import store from '@/store';

export default defineComponent({
	props: {
		post: {
			type: Object as PropType<Post>,
			required: true,
		},
		location: {
			type: String,
		},
		fullDate: {
			type: Boolean,
		},
	},
	setup(props) {
		const route = useRoute();
		const router = useRouter();
		const shareEnabled = ref(false);

		const subreddit = ref(store.subreddits.state.subreddits.find((x) => x.id === props.post.subreddit_id));

		const createDateText = (date: Date) => timeago.format(date);

		async function deletePost() {
			await store.post.actions.deletePost(props.post.id);
			if (props.location === 'post') {
				if (window.history.state.back) router.go(-1);
				else router.push({ path: `/r/${subreddit.value?.name}` });
			}
		}

		return {
			route,
			props,
			createDateText,
			shareEnabled,
			store,
			deletePost,
			subreddit,
		};
	},
});
